// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";

// Contexts
import AuthProvider from "./contexts/AuthContext"; // FIXED: Default import
import { ThemeContextProvider } from "./contexts/ThemeContext";
import { StoreProvider } from "./contexts/StoreContext";

// Render
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode> // Disable if causing double-mount issues
  <BrowserRouter>
    <AuthProvider>
      <StoreProvider>
        <ThemeContextProvider> {/* Global Theme Wrapper */}
          <App />
        </ThemeContextProvider>
      </StoreProvider>
    </AuthProvider>
  </BrowserRouter>
  // </React.StrictMode>
);
